{
  "account.copy": "Kopieren",
  "account.created.claudeCode": "Claude Code",
  "account.created.done": "Fertig",
  "account.created.json": "Clients, die mit JSON konfiguriert werden (zum Beispiel die .mcp.json eines Projekts)",
  "account.created.once": "Kopieren Sie das Token jetzt. Es wird nur dieses eine Mal angezeigt; KSS behält nur einen Fingerabdruck davon.",
  "account.created.title": "Token „{name}“",
  "account.expiry.1y": "einem Jahr",
  "account.expiry.30d": "30 Tagen",
  "account.expiry.90d": "90 Tagen",
  "account.expiry.never": "läuft nie ab",
  "account.mcp": "MCP-Connector",
  "account.mcp.address": "Adresse des Connectors:",
  "account.mcp.disabled": "Ein Administrator hat den MCP-Connector ausgeschaltet.",
  "account.mcp.sub": "Lassen Sie einen KI-Assistenten in Ihrem Namen mit KSS arbeiten. Er kann, was Sie können, in den Grenzen seines Tokens.",
  "account.refused.admin_only": "Nur Administratoren können ein Token mit Serververwaltung erzeugen.",
  "account.refused.disabled": "Der MCP-Connector ist ausgeschaltet.",
  "account.refused.expiry": "Wählen Sie, wann das Token abläuft.",
  "account.refused.name": "Geben Sie dem Token einen Namen.",
  "account.refused.rights": "Diese Rechte gibt es nicht.",
  "account.refused.too_many": "Sie haben schon so viele Tokens wie erlaubt. Widerrufen Sie zuerst eines.",
  "account.refused.workspace": "Wählen Sie nur Arbeitsbereiche, denen Sie angehören.",
  "account.rights.admin": "Lesen, schreiben und Server verwalten",
  "account.rights.read": "Lesen",
  "account.rights.write": "Lesen und schreiben",
  "account.title": "Konto",
  "account.tokens": "Tokens",
  "account.tokens.allWorkspaces": "alle Arbeitsbereiche",
  "account.tokens.allWorkspacesLong": "Alle meine Arbeitsbereiche, auch künftige",
  "account.tokens.create": "Token erzeugen",
  "account.tokens.expires": "läuft ab: {date}",
  "account.tokens.expiry": "Läuft ab nach",
  "account.tokens.lastUsed": "zuletzt benutzt: {date}",
  "account.tokens.name": "Name",
  "account.tokens.namePlaceholder": "z. B. Claude auf meinem Laptop",
  "account.tokens.never": "nie",
  "account.tokens.new": "Neues Token …",
  "account.tokens.none": "Noch keine Tokens.",
  "account.tokens.notYet": "noch nicht",
  "account.tokens.revoke": "Widerrufen",
  "account.tokens.revoked": {
    "one": "{count} widerrufenes Token",
    "other": "{count} widerrufene Tokens"
  },
  "account.tokens.rights": "Rechte",
  "account.tokens.workspaces": "Arbeitsbereiche",
  "app.account": "Ihr Konto und MCP-Tokens",
  "app.handbook": "Handbuch",
  "app.help": "Hilfe zu dieser Seite",
  "app.language": "Sprache der Oberfläche",
  "app.logOut": "Abmelden",
  "auth.adminOnly": "Mit einem Passwort können sich hier nur Administratoren anmelden.",
  "auth.adminSignIn": "Anmeldung für Administratoren",
  "auth.error.failed": "Die Anmeldung wurde nicht abgeschlossen. Bitte versuchen Sie es erneut.",
  "auth.error.group": "Ihr Konto ist nicht für KSS freigeschaltet. Bitten Sie eine Administratorin oder einen Administrator um Zugang.",
  "auth.error.unavailable": "Der Anmeldedienst ist zurzeit nicht erreichbar.",
  "auth.invalid": "Benutzername oder Passwort ist falsch.",
  "auth.orLocal": "oder mit einem lokalen Konto",
  "auth.password": "Passwort",
  "auth.passwordDisabled": "Die Anmeldung mit Passwort ist deaktiviert.",
  "auth.signIn": "Beim Knowledge Storage System anmelden",
  "auth.submit": "Anmelden",
  "auth.username": "Benutzername",
  "auth.withProvider": "Mit {provider} anmelden",
  "block.add": "Block hinzufügen",
  "block.copied": {
    "one": "{count} Block kopiert",
    "other": "{count} Blöcke kopiert"
  },
  "block.drag": "Block ziehen",
  "block.drag.title": "Ziehen zum Verschieben · Strg/⌘-Klick zum Auswählen",
  "block.drag.titleReadOnly": "Strg/⌘-Klick zum Auswählen",
  "block.emptyPage": "Leere Seite.",
  "block.issues.dangling_link": "verwaiste Verknüpfung",
  "block.issues.deprecated_term": "veralteter Begriff",
  "block.issues.derived_edge": "vorgeschlagene Verknüpfung",
  "block.issues.grounding": "Zuordnungsfrage",
  "block.issues.lww_conflict": "widersprüchliche Änderung",
  "block.issues.shacl_violation": "Verstoß gegen eine Form",
  "block.menu": "Blockmenü",
  "block.menu.copy": "Kopieren",
  "block.menu.copyIri": "Block-IRI kopieren",
  "block.menu.copyN": "{count} Blöcke kopieren",
  "block.menu.delete": "Löschen",
  "block.menu.detach": "Lösen (Kopie anlegen)",
  "block.menu.down": "Nach unten",
  "block.menu.intoGroup": "In die Gruppe darüber verschieben",
  "block.menu.link": "Verknüpfen …",
  "block.menu.links": "Verknüpfungen …",
  "block.menu.openOriginal": "Original öffnen",
  "block.menu.outOfGroup": "Aus der Gruppe heraus",
  "block.menu.pasteAfter": "Danach einfügen …",
  "block.menu.pasteInto": "In die Gruppe einfügen …",
  "block.menu.role": "Rolle festlegen …",
  "block.menu.sequence": "Zu Abfolge hinzufügen …",
  "block.menu.untitledSequence": "(ohne Titel)",
  "block.menu.up": "Nach oben",
  "block.mirror.confirmDelete": "Dadurch wird der Block aus „{source}“ und aus jedem seiner Spiegel gelöscht.",
  "block.mirror.unavailable": "Das Original ist nicht verfügbar, daher lässt sich der Spiegel nicht lösen.",
  "block.none": "Keine Blöcke.",
  "block.paste": "Einfügen",
  "block.resize": "Blockgröße ändern",
  "block.resize.title": "Ziehen zum Ändern der Größe · Doppelklick setzt zurück",
  "block.type.audio": "Audio",
  "block.type.checklist": "Checkliste",
  "block.type.chemistry": "Chemische Struktur",
  "block.type.code": "Code",
  "block.type.externalVideo": "Externes Video",
  "block.type.file": "Datei",
  "block.type.graphView": "Graphansicht",
  "block.type.group": "Gruppe",
  "block.type.image": "Bild",
  "block.type.mermaid": "Mermaid-Diagramm",
  "block.type.mirror": "Spiegel",
  "block.type.pageLink": "Link auf eine Seite",
  "block.type.reaction": "Reaktion",
  "block.type.section": "Textabschnitt",
  "block.type.table": "Tabelle",
  "block.type.url": "URL",
  "block.type.video": "Video",
  "block.type.webpage": "Webseite",
  "checklist.add": "Eintrag hinzufügen",
  "checklist.delete": "Eintrag löschen",
  "checklist.done": "Erledigt",
  "checklist.drag": "Eintrag ziehen",
  "checklist.hideDone": "Erledigte ausblenden",
  "checklist.progress": "{done} / {total} erledigt",
  "checklist.title": "Checkliste",
  "checklist.todo": "Zu erledigen",
  "chem.changedRemotely": "Anderswo geändert",
  "chem.edit": "Bearbeiten",
  "chem.empty": "Noch keine Struktur.",
  "chem.emptyEdit": "Noch keine Struktur – klicken Sie auf Bearbeiten, um eine zu zeichnen.",
  "chem.kind.molecule": "Molekül",
  "chem.kind.reaction": "Reaktion",
  "chem.loading": "Ketcher wird geladen …",
  "chem.needArrow": "Zeichnen Sie zuerst einen Reaktionspfeil: Ein Reaktionsblock speichert nur Reaktionen.",
  "chem.overwrite": "Mit meiner überschreiben",
  "chem.reloadRemote": "Fremde Fassung laden",
  "chem.title.reaction": "Reaktion",
  "chem.title.structure": "Chemische Struktur",
  "code.label": "Code",
  "common.cancel": "Abbrechen",
  "common.close": "Schließen",
  "common.done": "Fertig",
  "common.edit": "bearbeiten",
  "common.label": "Bezeichnung",
  "common.loading": "Wird geladen …",
  "common.remove": "entfernen",
  "common.removeEntry": "Entfernen",
  "common.save": "Speichern",
  "concepts.delete": "Konzept löschen",
  "concepts.empty": "Noch keine Konzepte im Arbeitsbereich.",
  "concepts.new": "Neues Konzept",
  "concepts.title": "Konzepte",
  "delete.body": "Die Seite kommt in den Papierkorb des Arbeitsbereichs, aus dem sie wiederhergestellt werden kann. Verknüpfungen anderer Seiten auf ihre Blöcke erscheinen im Prüfeingang als verwaist, bis sie zurückkommt. Nichts wird endgültig entfernt: Verlauf und Dateien bleiben erhalten.",
  "delete.dialog": "Seite löschen",
  "delete.heading": "„{title}“ löschen?",
  "export.button": "Exportieren …",
  "export.notes": {
    "one": "{count} Hinweis im Manifest des Archivs.",
    "other": "{count} Hinweise im Manifest des Archivs."
  },
  "export.offline": "Der Export braucht den Server",
  "export.preparing": "Archiv wird vorbereitet …",
  "export.title": "Diese Seite und ihre Dateien als .kss.zip-Archiv exportieren",
  "export.unsynced": "Nicht synchronisierte Änderungen sind nicht enthalten.",
  "extract.failed": "fehlgeschlagen",
  "extract.failedWith": "fehlgeschlagen: {error}",
  "extract.progress": "extrahiere {done}/{total} …",
  "extract.run": "Extrahieren",
  "extract.title": "Wissensgraph-Kandidaten aus dieser Seite mit dem Sprachmodell extrahieren",
  "extract.triples": {
    "one": "{count} Kandidaten-Tripel",
    "other": "{count} Kandidaten-Tripel"
  },
  "file.download": "herunterladen",
  "file.downloadButton": "Herunterladen",
  "file.inA": "in einem",
  "file.inline": "im Browser öffnen",
  "file.name": "Datei",
  "file.newTab": "neuen Tab",
  "file.newWindow": "neuen Fenster",
  "file.offline": "offline nicht verfügbar",
  "file.open": "Öffnen",
  "file.unknownType": "unbekannter Typ",
  "file.whenOpened": "Beim Öffnen",
  "graph.autoCentre": "Beim erneuten Ausführen zentrieren",
  "graph.blockTitle": "Graphansicht",
  "graph.builder.error": "Der Abfrage-Baukasten ließ sich nicht laden. Der SPARQL-Editor darunter funktioniert weiterhin.",
  "graph.builder.loading": "Der Abfrage-Baukasten wird geladen …",
  "graph.builder.open": "Abfrage zusammenstellen",
  "graph.builder.openBlock": "Abfrage zusammenstellen …",
  "graph.builder.use": "Abfrage übernehmen",
  "graph.choosePage": "Seite wählen …",
  "graph.fit": "Graph einpassen",
  "graph.graphView": "Graphansicht",
  "graph.groupByPage": "nach Seite gruppieren",
  "graph.hideDerived": "abgeleitete Duplikate ausblenden",
  "graph.insertPrefixes": "Präfixe einfügen",
  "graph.layout.elk": "ELK geschichtet",
  "graph.layout.preset": "gespeichert",
  "graph.nodes": {
    "one": "{count} Knoten",
    "other": "{count} Knoten"
  },
  "graph.rows": {
    "one": "{count} Zeile",
    "other": "{count} Zeilen"
  },
  "graph.run": "Ausführen",
  "graph.runHint": "Strg/⌘-Enter führt aus",
  "graph.running": "läuft …",
  "graph.saveAsBlock": "Als Block speichern",
  "graph.staleSince": "veraltet seit {time}",
  "graph.tableView": "Tabellenansicht",
  "graph.template.annotations": "Anmerkungen an einem Block",
  "graph.template.blocksByPage": "Alle Blöcke und ihre Seiten",
  "graph.template.chebi": "Blöcke, die eine chemische Entität erwähnen (ChEBI-Unterklassen)",
  "graph.template.derivedPending": "Abgeleitete Verknüpfungen, die auf Prüfung warten",
  "graph.template.inchikeys": "Strukturen und Beteiligte nach InChIKey",
  "graph.template.neighbourhood": "Umgebung eines Blocks",
  "graph.template.pageLinks": "Alle Verknüpfungen einer Seite",
  "graph.template.sequences": "Mitglieder von Abfolgen",
  "graph.templates": "Vorlagen",
  "graph.toggleEditor": "Abfrageeditor ein-/ausblenden",
  "graph.tooLarge": "großes Ergebnis: Tabellenansicht",
  "graph.truncated": "gekürzt",
  "graph.typeEdges": "Typ-Kanten",
  "graph.zoom": "Zoom",
  "graph.zoomIn": "Vergrößern",
  "graph.zoomOut": "Verkleinern",
  "group.collapse": "Gruppe zuklappen",
  "group.expand": "Gruppe aufklappen",
  "group.title": "Gruppentitel",
  "image.alt": "Alternativtext",
  "import.blocks": {
    "one": "{count} Block",
    "other": "{count} Blöcke"
  },
  "import.button": "Seite importieren …",
  "import.files": {
    "one": "{count} Datei",
    "other": "{count} Dateien"
  },
  "import.importing": "Wird importiert …",
  "import.links": {
    "one": "{count} Arbeitsbereichs-Verknüpfung",
    "other": "{count} Arbeitsbereichs-Verknüpfungen"
  },
  "import.offline": "Der Import braucht den Server",
  "import.open": "Seite öffnen",
  "import.refused": "Import abgelehnt: {error}",
  "import.sequences": {
    "one": "{count} Abfolge",
    "other": "{count} Abfolgen"
  },
  "import.summary": "„{title}“ importiert: {blocks}, {files}; Konzepte: zugeordnet {matched}, angelegt {created}; {sequences}, {links}.",
  "import.title": "Eine aus KSS exportierte Seite (.kss.zip) als neue Seite importieren",
  "import.tooLarge": "das Archiv ist zu groß",
  "import.uploadFailed": "das Hochladen ist fehlgeschlagen",
  "import.uploading": "Wird hochgeladen … {percent} %",
  "inspector.copyIri": "IRI kopieren",
  "inspector.edges": "Kanten ({count})",
  "inspector.empty": "Wählen Sie einen Knoten, um ihn anzusehen. Ein Doppelklick blendet seine Nachbarn ein.",
  "inspector.expand": "Erweitern",
  "inspector.open": "Öffnen",
  "inspector.properties": "Eigenschaften",
  "inspector.stale": "veraltet",
  "inspector.style": "Stil {style}",
  "inspector.types": "Typen",
  "inspector.variables": "Ergebnisvariablen",
  "linkDialog.add": "Verknüpfung hinzufügen",
  "linkDialog.chooseTarget": "Ziel wählen",
  "linkDialog.datatype": "Datentyp",
  "linkDialog.deprecated": "veraltet",
  "linkDialog.noConcepts": "Noch keine Konzepte im Arbeitsbereich — legen Sie eines in der Seitenleiste des Arbeitsbereichs an.",
  "linkDialog.note": "Notiz (optional)",
  "linkDialog.only": "nur Begriffe vom Typ {class}",
  "linkDialog.otherIri": "Andere IRI …",
  "linkDialog.page": "Seite",
  "linkDialog.predicate": "Prädikat",
  "linkDialog.search": "Suchen …",
  "linkDialog.tab.blocks": "Blöcke",
  "linkDialog.tab.concepts": "Konzepte",
  "linkDialog.tab.iri": "IRI",
  "linkDialog.tab.literal": "Wert",
  "linkDialog.tab.terms": "Ontologie-Begriffe",
  "linkDialog.takesType": "Dieses Prädikat erwartet einen Wert vom Typ {type}.",
  "linkDialog.target": "Ziel",
  "linkDialog.title": "Diesen Block verknüpfen",
  "linkDialog.unconstrained": "Durch keine Form eingeschränkt: Dieses Prädikat liegt außerhalb der importierten Ontologien.",
  "linkDialog.valueNotLink": "Ein Wert statt einer Verknüpfung mit etwas.",
  "linkDialog.workspaceConcept": "Konzept des Arbeitsbereichs",
  "links.close": "schließen",
  "links.facts": "Fakten",
  "links.facts.about": "Bezieht sich auf (optional)",
  "links.facts.aboutLabel": "über {term}",
  "links.facts.add": "Fakt hinzufügen",
  "links.facts.kind": "Art",
  "links.facts.lead": "Werte, die über diesen Block festgehalten sind.",
  "links.facts.noKind": "(ohne Art)",
  "links.facts.note": "Notiz",
  "links.facts.remove": "Fakt entfernen",
  "links.facts.unit": "Einheit",
  "links.facts.value": "Wert",
  "links.from": "von {source}",
  "links.group.alternatives": "Alternativen",
  "links.group.any": "beliebige Kombination",
  "links.group.atLeastOne": "mindestens eine",
  "links.group.cancel": "abbrechen",
  "links.group.choose": "Diese Möglichkeit wählen",
  "links.group.create": {
    "one": "{count} Verknüpfung gruppieren",
    "other": "{count} Verknüpfungen gruppieren"
  },
  "links.group.custom": "zwischen n und m …",
  "links.group.dissolve": "auflösen",
  "links.group.exactlyN": "genau {n}",
  "links.group.exactlyOne": "genau eine",
  "links.group.labelPlaceholder": "Bezeichnung (optional), z. B. Speicher-Backend",
  "links.group.orMore": "{min} oder mehr",
  "links.group.range": "{min} bis {max}",
  "links.group.takeOut": "Aus der Gruppe nehmen",
  "links.group.tooMany": "zu viele gewählt",
  "links.group.ungroup": "herausnehmen",
  "links.groupAsAlternatives": "Als Alternativen gruppieren …",
  "links.incoming": "Eingehend",
  "links.incomingNeedServer": "Offline — eingehende Verknüpfungen benötigen den Server.",
  "links.none": "Noch keine Verknüpfungen.",
  "links.noneShort": "Keine.",
  "links.outgoing": "Ausgehend",
  "links.promoted": "aus der Extraktion übernommen",
  "links.prov.asserted": "festgehalten",
  "links.prov.computed": "berechnet",
  "links.prov.derived": "abgeleitet",
  "links.prov.ontology": "Ontologie",
  "links.remove": "Verknüpfung entfernen",
  "links.select": "Verknüpfung auswählen",
  "links.short.block": "Block {id}",
  "links.short.concept": "Konzept {id}",
  "links.short.page": "Seite",
  "links.title": "Verknüpfungen",
  "literal.aValue": "ein Wert",
  "literal.needLang": "eine Sprachangabe wird benötigt, z. B. en oder de",
  "literal.needValue": "ein Wert wird benötigt",
  "literal.not.boolean": "kein Wahrheitswert",
  "literal.not.date": "kein Datum",
  "literal.not.dateTime": "kein Datum mit Uhrzeit",
  "literal.not.decimal": "keine Dezimalzahl",
  "literal.not.integer": "keine ganze Zahl",
  "literal.notDate": "kein gültiges Datum",
  "literal.notUri": "keine URI",
  "literal.type.boolean": "Wahrheitswert",
  "literal.type.date": "Datum",
  "literal.type.dateTime": "Datum und Uhrzeit",
  "literal.type.decimal": "Dezimalzahl",
  "literal.type.integer": "ganze Zahl",
  "literal.type.langString": "Text mit Sprachangabe",
  "literal.type.string": "Zeichenkette",
  "literal.type.text": "Text",
  "literal.type.uri": "URI",
  "media.caption": "Bildunterschrift",
  "media.choose": "eine Datei wählen",
  "media.drop": "Datei hierher ziehen oder",
  "media.hashing": "Prüfsumme … {percent} %",
  "media.none": "Keine Medien",
  "media.offline": "{name} (offline nicht verfügbar)",
  "media.replace": "ersetzen",
  "media.uploadFailed": "Hochladen fehlgeschlagen: {error}",
  "media.uploadState.queued": "wartet … {percent} %",
  "media.uploadState.uploading": "wird hochgeladen … {percent} %",
  "mermaid.hideSource": "Quelltext ausblenden",
  "mermaid.showSource": "Quelltext zeigen",
  "mirror.blockOn": "einem Block auf „{title}“",
  "mirror.deleted": "Das Original wurde gelöscht.",
  "mirror.forbidden": "Sie dürfen das Original nicht lesen.",
  "mirror.loop": "Spiegelschleife: Dieser Spiegel zeigt sich selbst.",
  "mirror.noOriginal": "Dieser Spiegel hat kein Original.",
  "mirror.of": "Spiegel von",
  "mirror.offline": "Das Original ist offline nicht verfügbar.",
  "mirror.otherWorkspace": "Das Original liegt nicht in diesem Arbeitsbereich.",
  "mirror.page": "„{title}“",
  "mirror.tooDeep": "Die Spiegel sind zu tief verschachtelt, um sie hier zu zeigen.",
  "offline.caching": "wird gespeichert …",
  "offline.cachingProgress": "wird gespeichert {done}/{total}",
  "offline.pin": "merken",
  "offline.pinned": "offline",
  "offline.title": "Offline verfügbar",
  "page.backToWorkspace": "← Arbeitsbereich",
  "page.copied": "Kopiert",
  "page.copyAll": "Alle Blöcke kopieren",
  "page.copyAll.title": "Alle Blöcke dieser Seite kopieren (einfügen als Kopie, Spiegel oder leere Struktur)",
  "page.opening": "Seite wird geöffnet …",
  "page.titlePlaceholder": "Seite ohne Titel",
  "page.untitled": "Ohne Titel",
  "page.width": "Seitenbreite",
  "page.width.full": "Volle Breite",
  "page.width.narrow": "Schmal",
  "page.width.wide": "Breit",
  "pageActions.delete": "Seite löschen …",
  "pageActions.delete.readOnly": "Sie können diese Seite nicht bearbeiten",
  "pageActions.linkPage": "Seite verknüpfen …",
  "pageActions.menu": "Seitenaktionen",
  "pageActions.restrict": "Schreibrechte einschränken …",
  "pageActions.restrict.ownerOnly": "Nur Eigentümer können Schreibrechte einschränken",
  "pageLink.change": "Seite wählen …",
  "pageLink.missing": "Die Seite gibt es nicht mehr, oder Sie dürfen sie nicht lesen.",
  "pageLink.noMatch": "Keine Seite passt.",
  "pageLink.none": "Noch keine Seite gewählt.",
  "pageLink.offline": "Offline – die Seitenliste braucht den Server.",
  "pageLink.search": "Seiten suchen …",
  "pageLink.trashed": "„{title}“ liegt im Papierkorb.",
  "paste.dialog": "Blöcke einfügen",
  "paste.mode.copy": "Inhalt kopieren",
  "paste.mode.copyHint": "Unabhängige Blöcke mit demselben Inhalt; Änderungen an ihnen lassen die Originale unberührt.",
  "paste.mode.empty": "Leere Struktur",
  "paste.mode.emptyHint": "Dieselben Blöcke und Verschachtelung mit Titeln, ohne Inhalt und Verknüpfungen.",
  "paste.mode.mirror": "Spiegeln",
  "paste.mode.mirrorHint": "Zeigt die Originale live: Eine Änderung an einem ändert beide.",
  "paste.paste": "Einfügen",
  "paste.pasting": "Wird eingefügt …",
  "paste.refuse.block": "Ein Block kann nicht in sich selbst gespiegelt werden.",
  "paste.refuse.missing": "Ein Original ist nicht mehr auf seiner Seite.",
  "paste.refuse.page": "Eine Seite kann sich nicht selbst spiegeln.",
  "paste.title.afterBlock": "Nach diesem Block einfügen",
  "paste.title.afterSelection": "Nach der Auswahl einfügen",
  "paste.title.atEnd": "Am Ende der Seite einfügen",
  "paste.title.intoGroup": "In diese Gruppe einfügen",
  "paste.whatBlocks": {
    "one": "{count} Block aus „{title}“",
    "other": "{count} Blöcke aus „{title}“"
  },
  "paste.whatPage": {
    "one": "die ganze Seite „{title}“: {count} Block",
    "other": "die ganze Seite „{title}“: {count} Blöcke"
  },
  "rail.addQuery": "Aus Abfrage hinzufügen …",
  "rail.arrow": "Pfeil",
  "rail.arrow.both": "an beiden Enden",
  "rail.arrow.none": "keiner",
  "rail.arrow.target": "am Ziel",
  "rail.button": "Beziehungen",
  "rail.cached": "zwischengespeichertes Ergebnis (offline)",
  "rail.closeStyle": "Stileditor schließen",
  "rail.colour": "Farbe",
  "rail.dash.dashdot": "Strichpunkt",
  "rail.dash.dashed": "gestrichelt",
  "rail.dash.dotted": "gepunktet",
  "rail.dash.solid": "durchgezogen",
  "rail.defaultStyle": "Standard",
  "rail.dialog.add": "Abfragespur hinzufügen",
  "rail.dialog.edit": "Abfragespur bearbeiten",
  "rail.dialog.intro": "Jede Ergebniszeile zeichnet einen Verbinder: <b>?source</b> und <b>?target</b> müssen Blöcke dieser Seite sein; <b>?label</b> ist optional. Die Ergebnisse werden zwischengespeichert, daher zeichnet die Spur auch offline.",
  "rail.editStyle": "Stil bearbeiten",
  "rail.elsewhere": "{count} anderswo, nicht gezeichnet",
  "rail.line": "Linie",
  "rail.newStyle": "Neuer Stil …",
  "rail.none": "Auf dieser Seite gibt es noch keine Verknüpfungen zwischen Blöcken.",
  "rail.offPage": {
    "one": "{count} Verknüpfung führt zu Blöcken auf anderen Seiten und wird nicht gezeichnet.",
    "other": "{count} Verknüpfungen führen zu Blöcken auf anderen Seiten und werden nicht gezeichnet."
  },
  "rail.offPageCount": "{count} außerhalb",
  "rail.onPage": "Beziehungen auf dieser Seite",
  "rail.query": "Abfrage",
  "rail.queryFailed": "Abfrage fehlgeschlagen: {error}",
  "rail.queryTracks": "Abfragespuren",
  "rail.rerun": "erneut ausführen",
  "rail.retry": "erneut versuchen",
  "rail.rowsOnPage": {
    "one": "{count} Zeile auf dieser Seite",
    "other": "{count} Zeilen auf dieser Seite"
  },
  "rail.show": "Beziehungsleiste anzeigen",
  "rail.showLabel": "Beschriftung",
  "rail.showPredicate": "{label} anzeigen",
  "rail.side": "Seite",
  "rail.side.left": "links",
  "rail.side.right": "rechts",
  "rail.style": "Stil",
  "rail.styleScope": "– gilt für jede Seite dieses Arbeitsbereichs",
  "rail.width": "Breite",
  "rail.ws.blockLinks": "Auch Verknüpfungen zwischen den Blöcken der Seiten zeigen, gezählt",
  "rail.ws.offTree": {
    "one": "{count} Verknüpfung führt zu einer Seite außerhalb des Baums und wird nicht gezeichnet.",
    "other": "{count} Verknüpfungen führen zu Seiten außerhalb des Baums und werden nicht gezeichnet."
  },
  "reaction.addAgent": "Agens hinzufügen",
  "reaction.addCondition": "Bedingung hinzufügen",
  "reaction.addQuantity": "Menge hinzufügen",
  "reaction.agents": "Agenzien",
  "reaction.coefficients": "Koeffizienten",
  "reaction.conditions": "Bedingungen",
  "reaction.drawFirst": "Zeichnen Sie zuerst die Reaktion.",
  "reaction.drawnCount": "Leer: die gezeichnete Anzahl verwenden",
  "reaction.empty": "Noch keine Reaktion.",
  "reaction.emptyEdit": "Noch keine Reaktion – klicken Sie auf Bearbeiten, um eine zu zeichnen.",
  "reaction.kind": "Art",
  "reaction.label": "Reaktion",
  "reaction.note": "Notiz",
  "reaction.quantities": "Mengen",
  "reaction.role.catalyst": "Katalysator",
  "reaction.role.reagent": "Reagenz",
  "reaction.role.solvent": "Lösungsmittel",
  "reaction.species": "Spezies (ChEBI)",
  "reaction.type": "Reaktionstyp",
  "reaction.typePlaceholder": "Namensreaktion (RXNO)",
  "reaction.unit": "Einheit",
  "reaction.value": "Wert",
  "restrict.body": "Ein eingeschränktes Mitglied kann diese Seite weiterhin <b>lesen</b>: Lesen gilt für den ganzen Arbeitsbereich. Inhalte, die manche Mitglieder nicht lesen dürfen, gehören in einen eigenen Arbeitsbereich. Wer die Seite gerade bearbeitet, wird von ihr getrennt.",
  "restrict.dialog": "Schreibrechte einschränken",
  "restrict.heading": "Schreibrechte für „{title}“ einschränken",
  "restrict.onlyViewers": "Hier gibt es nur Leser; sie können ohnehin nicht schreiben.",
  "results.showing": "{shown} von {total} Zeilen werden angezeigt.",
  "review.conflict.empty": "(leer)",
  "review.conflict.peer": "Teilnehmer {peer}",
  "review.conflict.title": "Widersprüchliche Änderungen an <b>{key}</b>",
  "review.conflict.use": "Diese Fassung verwenden",
  "review.dangling.deleted": "Das Ziel wurde gelöscht; stellen Sie es wieder her oder entfernen Sie die Verknüpfung an ihrem Block.",
  "review.dangling.from": "Von",
  "review.dangling.missing": "Das Ziel fehlt; es kann durch Rückgängig oder eine Wiederherstellung zurückkommen, dann erledigt sich dieser Punkt von selbst.",
  "review.dangling.title": "Eine Verknüpfung zeigt auf etwas, das es nicht mehr gibt",
  "review.dangling.to": "zu",
  "review.deprecated.apply": "Ersatz übernehmen",
  "review.deprecated.auto": {
    "one": "An {count} Stelle automatisch ersetzt.",
    "other": "An {count} Stellen automatisch ersetzt."
  },
  "review.deprecated.noReplacement": "Die Ontologie nennt keinen Ersatz; bitte von Hand neu verknüpfen.",
  "review.deprecated.notAuto": "Nicht automatisch ersetzt: {reason}",
  "review.deprecated.reason.auto_off": "Das automatische Ersetzen ist für diesen Arbeitsbereich ausgeschaltet.",
  "review.deprecated.reason.breaks_shape": "Der Ersatz würde dort, wo der Begriff verwendet wird, eine Regel (SHACL) verletzen.",
  "review.deprecated.reason.chain_too_long": "Die Kette der Ersatzbegriffe ist zu lang.",
  "review.deprecated.reason.cycle": "Die Ersatzbegriffe verweisen im Kreis aufeinander.",
  "review.deprecated.reason.kind_mismatch": "Der Ersatz ist eine andere Art von Begriff (zum Beispiel eine Relation statt einer Klasse).",
  "review.deprecated.reason.no_replacement": "Die Ontologie nennt keinen Ersatz.",
  "review.deprecated.reason.not_imported": "Der Ersatz ist noch nicht importiert; die Administration nimmt ihn in die Begriffsdatei der Ontologie auf.",
  "review.deprecated.reason.several_replacements": "Die Ontologie nennt mehr als einen Ersatz.",
  "review.deprecated.replacement": "Ersatz:",
  "review.deprecated.revert": "Rückgängig machen",
  "review.deprecated.reverted": "Rückgängig gemacht: Der alte Begriff steht wieder dort, wo der Ersatz stand.",
  "review.deprecated.usedBy": {
    "one": "ist veraltet · in {count} Dokument verwendet",
    "other": "ist veraltet · in {count} Dokumenten verwendet"
  },
  "review.dismiss": "Verwerfen",
  "review.edge.confidence": "Konfidenz {value}",
  "review.edge.derived": "abgeleitet",
  "review.edge.promote": "Übernehmen",
  "review.edge.reject": "Ablehnen",
  "review.empty": "Nichts zu prüfen.",
  "review.fact.about": "über {term}",
  "review.fact.promote": "Als Fakt übernehmen",
  "review.factUnit.ambiguous": "Das kann mehr als eine Einheit sein. Wählen Sie die gemeinte aus.",
  "review.factUnit.unknown": "KSS kennt für diese Größe keine so geschriebene Einheit. Wählen Sie die gemeinte aus oder verwerfen Sie den Eintrag.",
  "review.grounding.best": "beste Übereinstimmung {score}",
  "review.grounding.choose": "Wählen",
  "review.grounding.conceptLabel": "Bezeichnung des Konzepts",
  "review.grounding.createConcept": "Konzept anlegen",
  "review.grounding.in": "in",
  "review.grounding.noMatch": "keine nahe Übereinstimmung",
  "review.grounding.suggested": "vorgeschlagener Typ: {type}",
  "review.grounding.typeTitle": "Der vom Modell vorgeschlagene Typ; er grenzt nur die Kandidatensuche ein und wird nicht gespeichert",
  "review.kind.dangling_link": "Verwaiste Verknüpfungen",
  "review.kind.deprecated_term": "Veraltete Begriffe",
  "review.kind.derived_edge": "Abgeleitete Verknüpfungen",
  "review.kind.fact_unit": "Einheiten wählen",
  "review.kind.grounding": "Zuordnung",
  "review.kind.lww_conflict": "Konflikte",
  "review.kind.shacl_violation": "SHACL",
  "review.loadError": "Prüfpunkte konnten nicht geladen werden (nur online).",
  "review.openBlock": "Block öffnen",
  "review.shacl.default": "SHACL-Verstoß",
  "review.shacl.focus": "Fokusknoten:",
  "review.shacl.path": "Pfad",
  "review.shacl.value": "Wert",
  "review.status.dismissed": "Verworfen",
  "review.status.open": "Offen",
  "review.status.resolved": "Erledigt",
  "review.title": "Prüfen",
  "role.editor": "Bearbeiter",
  "role.intro": "Eine Rolle sagt, was der Block <b>ist</b> – eine Frage, eine Position, ein Schritt. Mehrere sind erlaubt.",
  "role.offline": "Offline – die Rollenliste braucht den Server.",
  "role.owner": "Eigentümer",
  "role.search": "Rollen suchen …",
  "role.title": "Was ist dieser Block?",
  "role.viewer": "Leser",
  "section.empty": "Leerer Abschnitt",
  "section.mode.markdown": "Markdown",
  "section.mode.rendered": "Gerendert",
  "section.mode.wysiwym": "WYSIWYM",
  "section.viewMode": "Ansicht",
  "seq.block": "Block {id}",
  "seq.create": "Abfolge anlegen",
  "seq.delete": "Abfolge löschen",
  "seq.empty": "Noch keine Abfolgen.",
  "seq.hint": "Fügen Sie Blöcke über ein Blockmenü hinzu.",
  "seq.moveDown": "Nach unten",
  "seq.moveUp": "Nach oben",
  "seq.name": "Name der Abfolge",
  "seq.new": "Neue Abfolge",
  "seq.title": "Abfolgen",
  "seq.untitled": "(ohne Titel)",
  "server.adminsOnly": "Diese Seite ist für Administratoren.",
  "server.choice.KM_RAIL_BUNDLE_GROUPS.bundle": "gebündelt",
  "server.choice.KM_RAIL_BUNDLE_GROUPS.separate": "einzelne Linien mit Klammer",
  "server.choice.KM_RAIL_BUNDLE_OVERLAP.larger": "das größere Bündel",
  "server.choice.KM_RAIL_BUNDLE_OVERLAP.origin": "immer das Ursprungsbündel",
  "server.discard": "Verwerfen",
  "server.environment": "Umgebung",
  "server.environment.sub": "In .env gesetzt und beim Start gelesen. Eine Änderung braucht einen Neustart des Servers.",
  "server.error.choice": "Wählen Sie einen der angebotenen Werte.",
  "server.error.host": "{host} steht nicht auf der Liste erlaubter Modell-Hosts des Servers (KM_LLM_ALLOWED_HOSTS in .env).",
  "server.error.integer": "Geben Sie eine ganze Zahl ein.",
  "server.error.length": "Das ist zu lang; höchstens {max} Zeichen.",
  "server.error.password": "Das Passwort ist zu schwach.",
  "server.error.range": "Geben Sie einen Wert von {min} bis {max} ein.",
  "server.error.required": "Das darf nicht leer sein.",
  "server.error.type": "Das ist nicht die richtige Art von Wert.",
  "server.error.unknown": "Diese Einstellung kann hier nicht geändert werden.",
  "server.error.url": "Geben Sie eine http- oder https-Adresse ein.",
  "server.group.decision": "Entscheidungsmodell",
  "server.group.decision.sub": "Ein optionales zweites Modell, das zwischen Kandidaten für die Verankerung wählt.",
  "server.group.extraction": "Extraktion",
  "server.group.extraction.sub": "Wie viel einer Seite und ihrer Dateien eine Extraktion liest.",
  "server.group.graph": "Graph-Abfragen",
  "server.group.graph.sub": "Grenzen für Abfragen an den Wissensgraphen.",
  "server.group.llm": "Sprachmodell",
  "server.group.llm.sub": "Das Modell, das Entitäten und Beziehungen aus Seiten extrahiert.",
  "server.group.mcp": "MCP-Connector",
  "server.group.mcp.sub": "KI-Assistenten, die über die Tokens von Personen mit KSS arbeiten.",
  "server.group.rail": "Beziehungsleiste",
  "server.group.rail.sub": "Wie die Beziehungsleiste neben Seiten Verbindungen zeichnet, die ein Ende teilen.",
  "server.group.sessions": "Sitzungen",
  "server.group.sessions.sub": "Verbindungen offener Seiten zum Synchronisierungsserver.",
  "server.group.signin": "Anmeldung",
  "server.group.signin.sub": "Wie man sich anmeldet.",
  "server.group.transfer": "Seitenarchive",
  "server.group.transfer.sub": "Seiten exportieren und importieren.",
  "server.group.web": "Webseiten",
  "server.group.web.sub": "Browsen und Einfrieren von Webseiten in Webseiten-Blöcken.",
  "server.hidden": "Die Umgebung setzt {value}; der hier gespeicherte Wert ersetzt ihn.",
  "server.history": "Verlauf",
  "server.history.command": "Ein Serverbefehl",
  "server.history.empty": "(leer)",
  "server.history.mcp.token_created": "hat das MCP-Token „{user}“ erzeugt.",
  "server.history.mcp.token_revoked": "hat das MCP-Token „{user}“ widerrufen.",
  "server.history.mcp.tokens_revoked": "hat alle MCP-Tokens von {user} widerrufen.",
  "server.history.mcp.write": "hat {user} über den MCP-Connector geändert.",
  "server.history.more": "Ältere zeigen",
  "server.history.none": "Noch wurde nichts geändert.",
  "server.history.setting.reset": "hat {setting} von {before} auf {after} zurückgesetzt.",
  "server.history.setting.saved": "hat {setting} von {before} auf {after} geändert.",
  "server.history.sub": "Jede Änderung auf dieser Seite, die neueste zuerst. Schlüssel werden als geändert vermerkt, nie ihr Wert.",
  "server.history.user.active.off": "hat {user} deaktiviert.",
  "server.history.user.active.on": "hat {user} reaktiviert.",
  "server.history.user.admin.off": "hat {user} die Administratorrechte entzogen.",
  "server.history.user.admin.on": "hat {user} zum Administrator gemacht.",
  "server.history.user.created": "hat den Benutzer {user} angelegt.",
  "server.history.user.edited": "hat {fields} von {user} geändert.",
  "server.history.user.password": "hat ein neues Passwort für {user} festgelegt.",
  "server.link": "Servereinstellungen",
  "server.needServer": "Dafür wird der Server gebraucht.",
  "server.reset": "Zurücksetzen",
  "server.save": "Speichern",
  "server.saved": "Gespeichert.",
  "server.secret.clear": "Leeren",
  "server.secret.new": "Neuer Schlüssel",
  "server.secret.notSet": "nicht gesetzt",
  "server.secret.replace": "Ersetzen …",
  "server.secret.set": "gesetzt",
  "server.secret.unreadable": "Der gespeicherte Schlüssel ist nicht mehr lesbar, vermutlich weil sich der geheime Schlüssel des Servers geändert hat. Geben Sie ihn erneut ein.",
  "server.setting.KM_AUTO_EXTRACT": "Automatisch extrahieren",
  "server.setting.KM_AUTO_EXTRACT.help": "Eine Seite nach Änderungen im Hintergrund extrahieren, in Arbeitsbereichen, die nichts anderes festlegen.",
  "server.setting.KM_DECISION_ACCEPT": "Annehmen ab",
  "server.setting.KM_DECISION_ACCEPT.help": "Eine Entscheidung mit mindestens dieser Sicherheit verankert die Entität ohne Prüfung.",
  "server.setting.KM_DECISION_ACCEPT_LOGPROBS": "Annehmen ab (logprobs)",
  "server.setting.KM_DECISION_ACCEPT_LOGPROBS.help": "Dasselbe für das Protokoll logprobs, dessen Sicherheit nicht kalibriert ist. 1,1 nimmt nie an.",
  "server.setting.KM_DECISION_BASE_URL": "Adresse",
  "server.setting.KM_DECISION_BASE_URL.help": "Die Adresse des Servers ohne /v1, zum Beispiel http://ollama:11434. Leer schaltet das Entscheidungsmodell aus.",
  "server.setting.KM_DECISION_COOLDOWN_S": "Pause nach einem Fehler",
  "server.setting.KM_DECISION_COOLDOWN_S.help": "Wie lange ein ausgefallener Endpunkt nicht mehr gefragt wird.",
  "server.setting.KM_DECISION_MODEL": "Modell",
  "server.setting.KM_DECISION_MODEL.help": "Der Name des Entscheidungsmodells.",
  "server.setting.KM_DECISION_PROTOCOL": "Protokoll",
  "server.setting.KM_DECISION_PROTOCOL.help": "systemone für einen Ollama-Entscheidungsendpunkt, logprobs für jedes Chat-Modell, auto probiert beides.",
  "server.setting.KM_DECISION_TIMEOUT": "Zeitlimit",
  "server.setting.KM_DECISION_TIMEOUT.help": "Wie lange auf eine Antwort gewartet wird, einschließlich Laden des Modells.",
  "server.setting.KM_EXTRACTION_MAX_NODES": "Blöcke pro Lauf",
  "server.setting.KM_EXTRACTION_MAX_NODES.help": "Die meisten Blöcke, die ein Extraktionslauf liest.",
  "server.setting.KM_FILE_PROMPT_MAX_BYTES": "Dateitext pro Prompt",
  "server.setting.KM_FILE_PROMPT_MAX_BYTES.help": "Wie viel dieses Textes ein Prompt erhält. Kleine lokale Modelle brauchen wenig.",
  "server.setting.KM_FILE_TEXT_MAX_BYTES": "Text pro Datei",
  "server.setting.KM_FILE_TEXT_MAX_BYTES.help": "Wie viel Text aus einer angehängten Datei behalten wird.",
  "server.setting.KM_GRAPH_MAX_ROWS": "Zeilen pro Abfrage",
  "server.setting.KM_GRAPH_MAX_ROWS.help": "Die meisten Zeilen, die eine Abfrage liefert.",
  "server.setting.KM_GRAPH_TIMEOUT_S": "Zeitlimit einer Abfrage",
  "server.setting.KM_GRAPH_TIMEOUT_S.help": "Wie lange eine Abfrage laufen darf.",
  "server.setting.KM_LLM_API_KEY": "API-Schlüssel",
  "server.setting.KM_LLM_API_KEY.help": "Wird als Bearer-Token gesendet. Nach dem Speichern wird er nie wieder angezeigt.",
  "server.setting.KM_LLM_BASE_URL": "Adresse",
  "server.setting.KM_LLM_BASE_URL.help": "Die OpenAI-kompatible Adresse des Modells, endet auf /v1. Nur Hosts auf der Liste erlaubter Hosts des Servers werden angenommen.",
  "server.setting.KM_LLM_MODEL": "Modell",
  "server.setting.KM_LLM_MODEL.help": "Der Name des Modells, wie der Endpunkt ihn kennt.",
  "server.setting.KM_MCP_ENABLED": "Connector an",
  "server.setting.KM_MCP_ENABLED.help": "Aus weist jedes Token sofort ab, und niemand kann neue erzeugen.",
  "server.setting.KM_MCP_INLINE_MAX_BYTES": "Größter Upload in einem Aufruf",
  "server.setting.KM_MCP_INLINE_MAX_BYTES.help": "Dateien bis zu dieser Größe dürfen in einem Tool-Aufruf mitgeschickt werden; größere nehmen eine Upload-Adresse.",
  "server.setting.KM_MCP_MAX_TOKENS": "Tokens pro Person",
  "server.setting.KM_MCP_MAX_TOKENS.help": "Die meisten gültigen Tokens, die eine Person haben darf.",
  "server.setting.KM_MCP_RATE_LIMIT": "Aufrufe pro Minute",
  "server.setting.KM_MCP_RATE_LIMIT.help": "Die meisten Tool-Aufrufe, die ein Token in einer Minute machen darf.",
  "server.setting.KM_OIDC_LABEL": "Beschriftung der Keycloak-Schaltfläche",
  "server.setting.KM_OIDC_LABEL.help": "Der Name auf der Anmeldeschaltfläche für Keycloak.",
  "server.setting.KM_OIDC_REQUIRED_GROUP": "Erforderliche Keycloak-Gruppe",
  "server.setting.KM_OIDC_REQUIRED_GROUP.help": "Nur Mitglieder dieser Gruppe dürfen sich über Keycloak anmelden. Leer lässt alle im Realm zu.",
  "server.setting.KM_PASSWORD_LOGIN": "Anmeldung mit Passwort",
  "server.setting.KM_PASSWORD_LOGIN.help": "Aus lässt nur die Anmeldung über Keycloak. Administratoren können sich immer mit Passwort anmelden.",
  "server.setting.KM_RAIL_BUNDLE_GROUPS": "Optionsgruppen",
  "server.setting.KM_RAIL_BUNDLE_GROUPS.help": "Ob die Verbindungen einer Optionsgruppe an einem Stamm verlaufen, mit der Beschriftung der Gruppe daran.",
  "server.setting.KM_RAIL_BUNDLE_OVERLAP": "Verbindung in zwei Bündeln",
  "server.setting.KM_RAIL_BUNDLE_OVERLAP.help": "Eine Verbindung, die ihren Ursprung mit einigen und ihr Ziel mit anderen teilt, gehört zu einem Bündel.",
  "server.setting.KM_SYNC_TOKEN_TTL_S": "Gültigkeit eines Sync-Tokens",
  "server.setting.KM_SYNC_TOKEN_TTL_S.help": "Wie lange das Sync-Token einer Seite gilt. Ein kürzeres beendet den Zugang eines entfernten Mitglieds früher.",
  "server.setting.KM_TRANSFER_MAX_BYTES": "Archivgröße",
  "server.setting.KM_TRANSFER_MAX_BYTES.help": "Das größte Seitenarchiv, das importiert werden kann.",
  "server.setting.KM_TRANSFER_TTL_S": "Archive aufbewahrt für",
  "server.setting.KM_TRANSFER_TTL_S.help": "Exportierte und importierte Archive werden danach gelöscht.",
  "server.setting.KM_WEB_BROWSING": "Web-Browsen",
  "server.setting.KM_WEB_BROWSING.help": "Aus beendet jedes Browsen in Webseiten-Blöcken; eingefrorene Schnappschüsse bleiben lesbar.",
  "server.setting.KM_WEB_DOM_MAX_BYTES": "Größe des Seitentexts",
  "server.setting.KM_WEB_DOM_MAX_BYTES.help": "Der größte Seitentext, der mit einem Schnappschuss gespeichert wird.",
  "server.setting.KM_WEB_RECORD_MAX_BYTES": "Aufnahmegröße",
  "server.setting.KM_WEB_RECORD_MAX_BYTES.help": "Das meiste, was eine Browsersitzung aufzeichnen darf.",
  "server.setting.KM_WEB_SESSION_TTL_S": "Lebensdauer einer Browsersitzung",
  "server.setting.KM_WEB_SESSION_TTL_S.help": "Aufnahmen älterer Sitzungen werden gelöscht; Schnappschüsse bleiben.",
  "server.setting.KM_WEB_SNAPSHOT_MAX_BYTES": "Schnappschussgröße",
  "server.setting.KM_WEB_SNAPSHOT_MAX_BYTES.help": "Der größte eingefrorene Schnappschuss.",
  "server.setting.KM_WEB_TOKEN_IDLE_S": "Untätiges Browsen endet nach",
  "server.setting.KM_WEB_TOKEN_IDLE_S.help": "Eine so lange ungenutzte Browsersitzung funktioniert nicht mehr.",
  "server.source.default": "Standard",
  "server.source.environment": "Umgebung",
  "server.source.saved": "hier gespeichert",
  "server.tab.history": "Verlauf",
  "server.tab.settings": "Einstellungen",
  "server.tab.users": "Benutzer",
  "server.test": "Verbindung testen",
  "server.test.answered": "{model} hat in {ms} ms geantwortet.",
  "server.test.format": "{model} hat in {ms} ms geantwortet, aber nicht im verlangten Format. Die Extraktion prüft trotzdem jede Antwort.",
  "server.test.host": "{message} steht nicht auf der Liste erlaubter Modell-Hosts des Servers.",
  "server.test.http": "Der Endpunkt hat mit einem Fehler geantwortet: {message}",
  "server.test.model_missing": "Erreicht, aber der Endpunkt bietet {model} nicht an. Er bietet: {message}",
  "server.test.patience": "Ein Modell, das noch nicht geladen ist, kann ein bis zwei Minuten brauchen.",
  "server.test.reached": "In {ms} ms erreicht; {model} ist verfügbar.",
  "server.test.running": "Teste …",
  "server.test.timeout": "Keine Antwort innerhalb von {message} s. Das Modell lädt vielleicht noch; versuchen Sie es in einer Minute erneut.",
  "server.test.unparseable": "Der Endpunkt hat etwas geantwortet, das kein JSON ist.",
  "server.test.unreachable": "Nicht erreichbar: {message}",
  "server.test.url": "Geben Sie zuerst eine http- oder https-Adresse ein.",
  "server.title": "Servereinstellungen",
  "server.users": "Benutzer",
  "server.users.admin": "Administrator",
  "server.users.col.lastLogin": "Letzte Anmeldung",
  "server.users.col.signIn": "Anmeldung mit",
  "server.users.col.user": "Benutzer",
  "server.users.col.workspaces": "Arbeitsbereiche",
  "server.users.create": "Benutzer anlegen",
  "server.users.deactivate": "Deaktivieren",
  "server.users.displayName": "Anzeigename",
  "server.users.edit": "Bearbeiten …",
  "server.users.editTitle": "{user} bearbeiten",
  "server.users.email": "E-Mail",
  "server.users.field.displayName": "Anzeigename",
  "server.users.field.email": "E-Mail",
  "server.users.guard.lastAdmin": "Der letzte Administrator bleibt.",
  "server.users.guard.oidc": "Das Passwort dieses Kontos liegt in Keycloak.",
  "server.users.guard.self": "Nicht für Ihr eigenes Konto.",
  "server.users.inactive": "deaktiviert",
  "server.users.isAdmin": "Administrator: darf die Servereinstellungen öffnen",
  "server.users.makeAdmin": "Zum Administrator machen",
  "server.users.mcpTokens": {
    "one": "{count} MCP-Token",
    "other": "{count} MCP-Tokens"
  },
  "server.users.menu": "Aktionen für {user}",
  "server.users.never": "nie",
  "server.users.new": "Neuer Benutzer",
  "server.users.newPassword": "Neues Passwort",
  "server.users.password": "Passwort festlegen …",
  "server.users.passwordTitle": "Neues Passwort für {user}",
  "server.users.reactivate": "Reaktivieren",
  "server.users.refused.last_admin": "Der Server braucht mindestens einen aktiven Administrator.",
  "server.users.refused.oidc": "Dieses Konto meldet sich über Keycloak an; sein Passwort liegt dort.",
  "server.users.refused.self": "Das ist für Ihr eigenes Konto nicht möglich.",
  "server.users.refused.system": "Systemkonten können nicht geändert werden.",
  "server.users.refused.username_taken": "Dieser Benutzername ist vergeben.",
  "server.users.removeAdmin": "Administratorrechte entziehen",
  "server.users.revokeTokens": "Alle MCP-Tokens widerrufen",
  "server.users.setPassword": "Passwort festlegen",
  "server.users.signIn.oidc": "Keycloak",
  "server.users.signIn.password": "Passwort",
  "server.users.sub": "Alle Konten auf diesem Server. Mitgliedschaften werden auf der Einstellungsseite des jeweiligen Arbeitsbereichs festgelegt.",
  "settings.confirm": "Bestätigen",
  "settings.confirm.allow": "Erlauben",
  "settings.confirm.auto.body": "Alle zehn Minuten werden veraltete Blöcke ohne Rückfrage an <b>{host}</b>{model} geschickt. Das kostet, was dieser Endpunkt kostet.",
  "settings.confirm.auto.title": "Automatisch extrahieren?",
  "settings.confirm.egress.body": "Die Extraktion darf dann den Text der Seiten dieses Arbeitsbereichs an <b>{host}</b>{model}{notListed} senden. Für alle anderen Arbeitsbereiche bleibt es ausgeschaltet.",
  "settings.confirm.egress.title": "Seitentext diesen Rechner verlassen lassen?",
  "settings.confirm.notListed": ", der nicht auf der Freigabeliste des Servers steht",
  "settings.delete.body": "Löschen verbirgt den Arbeitsbereich sofort vor allen Mitgliedern und trennt alle, die ihn geöffnet haben. Seine Seiten, ihr Verlauf und ihre Dateien bleiben erhalten, sodass die Serveradministration ihn wiederherstellen kann. Einzelne Seiten löschen Sie auf der Seite selbst und stellen sie aus dem Papierkorb des Arbeitsbereichs wieder her.",
  "settings.delete.button": "Arbeitsbereich löschen…",
  "settings.delete.confirm.body": "Alle Mitglieder verlieren sofort den Zugriff auf <b>{name}</b> und seine Seiten. Geben Sie zur Bestätigung den Namen des Arbeitsbereichs ein.",
  "settings.delete.confirm.label": "Name des Arbeitsbereichs",
  "settings.delete.confirm.ok": "Arbeitsbereich löschen",
  "settings.delete.confirm.title": "„{name}“ löschen?",
  "settings.delete.ownerOnly": "Nur Eigentümer können diesen Arbeitsbereich löschen.",
  "settings.delete.title": "Diesen Arbeitsbereich löschen",
  "settings.members": "Mitglieder",
  "settings.members.add": "Hinzufügen",
  "settings.members.already": "Diese Person ist schon Mitglied.",
  "settings.members.ambiguous": "Mehrere Personen haben diesen Namen. Nehmen Sie den Benutzernamen oder die E-Mail-Adresse.",
  "settings.members.keycloak": "Keycloak: {name}",
  "settings.members.needServer": "Mitglieder benötigen den Server.",
  "settings.members.newRole": "Rolle des neuen Mitglieds",
  "settings.members.notFound": "Kein Konto hat diesen Benutzernamen, diese E-Mail-Adresse, diesen Keycloak-Login oder diesen Namen.",
  "settings.members.oidc": "Keycloak bestimmt die Mitgliedschaft in diesem Arbeitsbereich: Änderungen hier werden bei der nächsten Anmeldung des Mitglieds überschrieben. Der letzte Eigentümer bleibt erhalten und wird als <b>manuell</b> markiert.",
  "settings.members.remove": "{user} entfernen",
  "settings.members.roleOf": "Rolle von {user}",
  "settings.members.sub": "Lesezugriff gilt für den ganzen Arbeitsbereich: Jedes Mitglied kann jede Seite lesen.",
  "settings.members.who": "Benutzername, E-Mail oder Name",
  "settings.members.you": "(Sie)",
  "settings.name": "Name",
  "settings.policy": "Richtlinien",
  "settings.policy.auto": "Automatische Extraktion",
  "settings.policy.auto.body": "Alle zehn Minuten werden Blöcke, deren Extraktion veraltet ist, erneut an das LLM geschickt. Anhänge werden nie automatisch verarbeitet. Die Server-Vorgabe ist {state}.",
  "settings.policy.egress": "LLM-Zugriff nach außen",
  "settings.policy.egress.body": "Die Extraktion darf einen Endpunkt außerhalb der Freigabeliste des Servers nutzen. Seitentext verlässt dann diesen Rechner in Richtung {host}{model}.",
  "settings.policy.endpoint": "den konfigurierten Endpunkt",
  "settings.policy.mcp": "MCP-Connectors",
  "settings.policy.mcp.body": "KI-Assistenten, die über das MCP-Token eines Mitglieds verbunden sind, dürfen diesen Arbeitsbereich lesen und mit Schreibrechten ändern. Aus sehen Tokens nichts davon.",
  "settings.policy.migrate": "Veraltete Ontologiebegriffe automatisch ersetzen",
  "settings.policy.migrate.body": "Wenn eine Ontologie einen Begriff zurückzieht und genau einen sicheren Nachfolger nennt, ersetzt KSS ihn selbst auf allen Seiten. Jede Ersetzung erscheint im Prüfeingang und lässt sich dort rückgängig machen. Alles, was weniger eindeutig ist, bleibt eine Frage für einen Menschen.",
  "settings.policy.off": "aus",
  "settings.policy.on": "an",
  "settings.policy.serverDefault": "Server-Vorgabe",
  "settings.policy.web": "Web-Browsen",
  "settings.policy.web.body": "Webseiten-Blöcke dürfen Live-Seiten über den aufzeichnenden Proxy aufrufen. Eingefrorene Momentaufnahmen werden in jedem Fall angezeigt.",
  "settings.readOnly": "Sie sehen die Einstellungen dieses Arbeitsbereichs; ändern können sie nur Eigentümer.",
  "settings.rename": "Umbenennen",
  "settings.restricted": "Seiten mit eingeschränkten Schreibrechten",
  "settings.restricted.forYou": "für Sie schreibgeschützt",
  "settings.restricted.none": "Keine Seite schränkt das Schreiben ein.",
  "settings.restricted.sub": "Die Schreibrechte einer Seite stellt man auf der Seite selbst ein, unter „Schreibrechte einschränken …“.",
  "settings.title": "Einstellungen",
  "sync.connecting": "verbinden …",
  "sync.error": "Synchronisationsfehler",
  "sync.forbidden": "kein Zugriff",
  "sync.offline": "offline",
  "sync.synced": "synchron",
  "sync.syncing": "synchronisieren …",
  "table.align.center": "Zentriert",
  "table.align.left": "Linksbündig",
  "table.align.right": "Rechtsbündig",
  "table.caption": "Beschriftung (optional)",
  "table.colLeft": "Spalte links einfügen",
  "table.colRight": "Spalte rechts einfügen",
  "table.copied": "Kopiert",
  "table.copy": "Als Markdown kopieren",
  "table.deleteColumn": "Spalte löschen",
  "table.deleteRow": "Zeile löschen",
  "table.rowAbove": "Zeile darüber einfügen",
  "table.rowBelow": "Zeile darunter einfügen",
  "tb.bold": "Fett (Strg/⌘+B)",
  "tb.bullet": "Aufzählung",
  "tb.code": "Code im Text (Strg/⌘+`)",
  "tb.formatting": "Formatierung",
  "tb.heading": "Überschrift {level}",
  "tb.indent": "Listeneintrag einrücken",
  "tb.italic": "Kursiv (Strg/⌘+I)",
  "tb.link": "Link",
  "tb.linkInvalid": "Nur http-, https- und mailto-Links sind erlaubt.",
  "tb.linkPrompt": "Link-URL (https://…)",
  "tb.linkPromptEdit": "Link-URL (leer entfernt den Link)",
  "tb.ordered": "Nummerierte Liste",
  "tb.outdent": "Listeneintrag ausrücken",
  "tb.paragraph": "Absatz",
  "tb.quote": "Zitat",
  "tb.redo": "Wiederholen",
  "tb.rule": "Trennlinie",
  "tb.strike": "Durchgestrichen",
  "tb.undo": "Rückgängig",
  "termPicker.free": "kein Ontologiebegriff",
  "trash.deletedOn": "gelöscht am {date}",
  "trash.restore": "Wiederherstellen",
  "trash.title": "Papierkorb ({count})",
  "tree.collapse": "Ordner zuklappen",
  "tree.copyFolderIri": "Ordner-IRI kopieren",
  "tree.copyPageIri": "Seiten-IRI kopieren",
  "tree.deleteFolder": "Ordner löschen",
  "tree.dissolve": "Ordner auflösen",
  "tree.dragFolder": "Ordner ziehen",
  "tree.dragPage": "Seite ziehen",
  "tree.expand": "Ordner aufklappen",
  "tree.folderTitle": "Ordnername",
  "tree.intoFolderAbove": "In den Ordner darüber verschieben",
  "tree.items": {
    "one": "{count} Eintrag",
    "other": "{count} Einträge"
  },
  "tree.menu": "Seitenmenü",
  "tree.newFolder": "Neuer Ordner",
  "tree.newFolderHere": "Neuer Ordner hier",
  "tree.newFolderTitle": "Neuer Ordner",
  "tree.newPageHere": "Neue Seite hier",
  "tree.outOfFolder": "Aus dem Ordner verschieben",
  "urlBlock.action.browser": "im Browser öffnen",
  "urlBlock.action.copy": "Link kopieren",
  "urlBlock.action.system": "mit der System-App öffnen",
  "urlBlock.address": "Adresse",
  "urlBlock.caption": "Text, der als Link erscheint (optional)",
  "urlBlock.copied": "Link kopiert",
  "urlBlock.empty": "keine Adresse",
  "urlBlock.hint": "Geben Sie unten eine Adresse ein oder fügen Sie sie ein.",
  "urlBlock.noScheme": "ein Schema wie https:// ergänzen",
  "urlBlock.none": "Noch keine Adresse.",
  "urlBlock.refused": "{scheme}:-Links sind nicht erlaubt",
  "urlBlock.systemHint": "für App-Links wie mailto: oder zotero:; eine Webadresse öffnet sich im Browser",
  "urlBlock.whenClicked": "Beim Klicken",
  "video.badUrl": "Keine gültige http(s)-URL",
  "video.frame": "Video",
  "video.load": "▶ {provider}-Player laden ({id})",
  "video.placeholder": "YouTube-, Vimeo- oder andere Video-URL einfügen",
  "web.back": "Zurück",
  "web.badAddress": "Geben Sie eine http(s)-Adresse ein.",
  "web.cannotOpen": "Die Webseite kann gerade nicht geöffnet werden.",
  "web.empty": "Noch keine Webseite.",
  "web.emptyEdit": "Geben Sie oben eine Adresse ein und drücken Sie die Eingabetaste.",
  "web.forward": "Vorwärts",
  "web.freeze": "Einfrieren",
  "web.freezeFailed": "Einfrieren fehlgeschlagen.",
  "web.freezeFailedWith": "Einfrieren fehlgeschlagen: {error}",
  "web.freezeTitle": "Diese Seite genau so behalten, wie sie jetzt ist",
  "web.freezing": "Wird eingefroren …",
  "web.frozenAt": "eingefroren am {date}",
  "web.noAddress": "Noch keine Adresse",
  "web.noAnswer": "Die Seite hat nicht geantwortet. Laden Sie sie neu und versuchen Sie es noch einmal.",
  "web.offline": "Offline nicht verfügbar – nur eingefrorene Seiten sind es.",
  "web.reload": "Neu laden",
  "web.replay": "Original abspielen",
  "web.replayTitle": "Die aufgezeichnete Seite mit ihren Skripten erneut ausführen, statt sie so zu zeigen, wie sie eingefroren wurde",
  "web.showSnapshot": "Diesen Schnappschuss zeigen",
  "web.shown": "angezeigt",
  "web.snapshotOffline": "Dieser Schnappschuss ist offline nicht verfügbar. Machen Sie die Seite offline verfügbar, um ihn zu behalten.",
  "web.snapshots": {
    "one": "{count} Schnappschuss",
    "other": "{count} Schnappschüsse"
  },
  "web.unfreeze": "Auftauen",
  "web.usePage": "Diese Seite übernehmen",
  "workspace.gone.body": "Ein Eigentümer hat ihn gelöscht, daher lassen sich seine Seiten nicht mehr öffnen oder bearbeiten. Fragen Sie den Eigentümer oder Ihre Serveradministration, wenn er zurückkommen soll.",
  "workspace.gone.home": "Zurück zu Ihren Arbeitsbereichen",
  "workspace.gone.title": "Dieser Arbeitsbereich wurde gelöscht",
  "ws.createPage": "Seite anlegen",
  "ws.fallbackName": "Arbeitsbereich",
  "ws.list.create": "Anlegen",
  "ws.list.deleted": "„{name}“ wurde gelöscht.",
  "ws.list.deleted.undo": "Rückgängig",
  "ws.list.empty": "Noch keine Arbeitsbereiche.",
  "ws.list.lead": "Jede Seite, jede Verknüpfung und jede Aussage liegt in einem davon.",
  "ws.list.newName": "Name des neuen Arbeitsbereichs",
  "ws.list.title": "Arbeitsbereiche",
  "ws.nav.graph": "Graph",
  "ws.nav.review": "Prüfen",
  "ws.nav.settings": "Einstellungen",
  "ws.newPageTitle": "Titel der neuen Seite",
  "ws.noPages": "Noch keine Seiten.",
  "ws.notInTree": "(nicht im Seitenbaum)",
  "ws.readOnly": "schreibgeschützt"
}
